import { closeLinkContextMenu } from '../components/LinkContextMenu';
import { getEndpointUrlFromCanonicalUrl } from 'owa-attachment-link-common';
import { lazyOpenSharingDialog, SharingDialogResponse } from 'owa-sharing-dialog';
import { SharingLinkInfo, updateSharingLinkFromSharingDialog } from 'owa-link-data';

export async function onOpenSharingDialogClicked(sharingLink: SharingLinkInfo) {
    closeLinkContextMenu();
    const openSharingDialog = await lazyOpenSharingDialog.import();

    const canonicalUrl = sharingLink.sharingInfo.canonicalUrl;
    const endpointUrl = getEndpointUrlFromCanonicalUrl(canonicalUrl);
    openSharingDialog(endpointUrl, canonicalUrl, sharingLink.sharingInfo.shareId)
        .then((response: SharingDialogResponse) => {
            updateSharingLinkFromSharingDialog(sharingLink.linkId, response);
        })
        .catch(() => {});
}
